export default {
  pageTitle: {
    id: 'bo_seller.kyb.review.page_title',
    defaultMessage: 'KYB - Review and submit',
  },
  title: {
    id: 'bo_seller.kyb.review.title',
    defaultMessage: 'Review and submit',
  },
  description: {
    id: 'bo_seller.kyb.review.description',
    defaultMessage:
      'Review all details to make sure they are accurate and complete. Once you submit, your information will be processed for verification.',
  },
  businessDetailsTitle: {
    id: 'bo_seller.kyb.review.business_details_title',
    defaultMessage: 'Business details',
  },
  businessDetailsLegalName: {
    id: 'bo_seller.kyb.review.business_details_legal_name',
    defaultMessage: 'Legal business name',
  },
  otherBeneficialOwnerOwnerDetails: {
    id: 'bo_seller.kyb.review.other_beneficial_owner_owner_details',
    defaultMessage: 'Other beneficial owner details',
  },
  businessDetailsTradeName: {
    id: 'bo_seller.kyb.review.business_details_trade_name',
    defaultMessage: 'Trade business name',
  },
  businessDetailsRegistrationCountry: {
    id: 'bo_seller.kyb.review.business_details_country_of_registration',
    defaultMessage: 'Country of registration',
  },
  businessDetailsRegistrationType: {
    id: 'bo_seller.kyb.review.business_details_registration_type',
    defaultMessage: 'Registration type',
  },
  businessDetailsRegistrationNumber: {
    id: 'bo_seller.kyb.review.business_details_registration_number',
    defaultMessage: 'Registration number',
  },
  businessDetailsIncorporationDate: {
    id: 'bo_seller.kyb.review.business_details_incorporation_date',
    defaultMessage: 'Incorporation date',
  },
  businessDetailsHeadquartersAddress: {
    id: 'bo_seller.kyb.review.business_details_headquarters_address',
    defaultMessage: 'Headquarters address',
  },
  articleOfIncorporation: {
    id: 'bo_seller.kyb.review.business_details_article_of_incorporation',
    defaultMessage: 'Article of incorporation',
  },
  businessDetailsInvestedCapital: {
    id: 'bo_seller.kyb.review.business_details_invested_capital',
    defaultMessage: 'Capital invested at incorporation',
  },
  businessDetailsInvestedCapitalCurrency: {
    id: 'bo_seller.kyb.review.business_details_invested_capital_currency',
    defaultMessage: 'Capital invested currency',
  },
  businessDetailsEditButton: {
    id: 'bo_seller.kyb.review.business_details_edit_button',
    defaultMessage: 'Edit',
  },
  accountRequesterTitle: {
    id: 'bo_seller.kyb.review.account_requester_title',
    defaultMessage: 'Account requester details',
  },
  accountRequesterEditButton: {
    id: 'bo_seller.kyb.review.account_requester_edit_button',
    defaultMessage: 'Edit',
  },
  legalRepresentativeTitle: {
    id: 'bo_seller.kyb.review.legal_representative_title',
    defaultMessage: 'Legal representative details',
  },
  legalRepresentativeSameAsAccountRequester: {
    id: 'bo_seller.kyb.review.legal_representative_same_as_account_requester',
    defaultMessage: 'Same as account requester',
  },
  legalRepresentativeEditButton: {
    id: 'bo_seller.kyb.review.legal_representative_edit_button',
    defaultMessage: 'Edit',
  },
  beneficialOwnerTitle: {
    id: 'bo_seller.kyb.review.beneficial_owner_title',
    defaultMessage: 'Beneficial owner details',
  },
  beneficialOwnerPrimaryOwner: {
    id: 'bo_seller.kyb.review.beneficial_owner_primary_owner',
    defaultMessage: 'Primary beneficial owner details',
  },
  beneficialOwnerSameAsAccountRequester: {
    id: 'bo_seller.kyb.review.beneficial_owner_same_as_account_requester',
    defaultMessage: 'Same as account requester',
  },
  beneficialOwnerSameAsLegalRepresentative: {
    id: 'bo_seller.kyb.review.beneficial_owner_same_as_legal_representative',
    defaultMessage: 'Same as legal representative',
  },
  beneficialOwnerEditButton: {
    id: 'bo_seller.kyb.review.beneficial_owner_edit_button',
    defaultMessage: 'Edit',
  },
  letterOfAuthorizationTitle: {
    id: 'bo_seller.kyb.review.letter_of_authorization_title',
    defaultMessage: 'Letter of authorization',
  },
  letterOfAuthorizationUploaded: {
    id: 'bo_seller.kyb.review.letter_of_authorization_uploaded',
    defaultMessage: 'Letter of authorization uploaded',
  },
  letterOfAuthorizationEditButton: {
    id: 'bo_seller.kyb.review.letter_of_authorization_edit_button',
    defaultMessage: 'Edit',
  },
  submitButton: {
    id: 'bo_seller.kyb.review.submit_button',
    defaultMessage: 'Submit',
  },
  submitSuccessTitle: {
    id: 'bo_seller.kyb.review.submit_success_title',
    defaultMessage: 'KYB submitted successfully',
  },
  submitSuccessContent: {
    id: 'bo_seller.kyb.review.submit_success_content',
    defaultMessage:
      'Your KYB application has been submitted for review. You will be notified once the verification is complete.',
  },
  submitErrorTitle: {
    id: 'bo_seller.kyb.review.submit_error_title',
    defaultMessage: 'Failed to submit KYB',
  },
} as const
